"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var React = require("react");

var core_1 = require("../core");

var renderer_1 = require("../app/renderer");
/** A React component that manages a sub-chart */


var ChartComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  function ChartComponent(props) {
    var _this;

    _classCallCheck(this, ChartComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChartComponent).call(this, props));

    _this.recreateManager(props);

    _this.updateWithNewProps(props);

    if (props.sync) {
      _this.manager.solveConstraints();

      _this.state = {
        working: false,
        graphics: _this.renderer.render()
      };
    } else {
      _this.state = {
        working: true,
        graphics: null
      };

      _this.scheduleUpdate();
    }

    return _this;
  }

  _createClass(ChartComponent, [{
    key: "applySelection",
    value: function applySelection(selection) {
      this.manager.enumeratePlotSegments(function (cls) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = core_1.zip(cls.state.dataRowIndices, cls.state.glyphs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var rowIndices = _ref2[0];
            var glyphState = _ref2[1];

            if (selection == null) {
              glyphState.emphasized = true;
            } else {
              glyphState.emphasized = selection.isSelected(cls.object.table, rowIndices);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (this.updateWithNewProps(newProps)) {
        this.setState({
          working: true
        });
        this.scheduleUpdate();
      } else if (newProps.selection != this.props.selection) {
        this.applySelection(newProps.selection);
        this.setState({
          graphics: this.renderer.render()
        });
      }
    }
  }, {
    key: "isEqual",
    value: function isEqual(a, b) {
      if (a == b) {
        return true;
      }

      return JSON.stringify(a) == JSON.stringify(b);
    }
  }, {
    key: "updateWithNewProps",
    value: function updateWithNewProps(newProps) {
      var changed = false;

      if (!this.isEqual(newProps.chart, this.props.chart)) {
        this.recreateManager(newProps);
        changed = true;
      } else if (!this.isEqual(newProps.dataset, this.props.dataset)) {
        this.manager.setDataset(newProps.dataset);
        changed = true;
      } else if (!this.isEqual(newProps.defaultAttributes, this.props.defaultAttributes)) {
        this.recreateManager(newProps);
        changed = true;
      }

      if (!this.manager.chart.mappings.width || newProps.width != this.manager.chart.mappings.width.value) {
        this.manager.chart.mappings.width = {
          type: "value",
          value: newProps.width
        };
        changed = true;
      }

      if (!this.manager.chart.mappings.height || newProps.height != this.manager.chart.mappings.height.value) {
        this.manager.chart.mappings.height = {
          type: "value",
          value: newProps.height
        };
        changed = true;
      }

      return changed;
    }
  }, {
    key: "recreateManager",
    value: function recreateManager(props) {
      this.manager = new core_1.Prototypes.ChartStateManager(core_1.deepClone(props.chart), props.dataset, null, props.defaultAttributes);
      this.renderer = new core_1.Graphics.ChartRenderer(this.manager);
    }
  }, {
    key: "scheduleUpdate",
    value: function scheduleUpdate() {
      var _this2 = this;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this2.timer = null;

        _this2.manager.solveConstraints();

        _this2.applySelection(_this2.props.selection);

        _this2.setState({
          working: false,
          graphics: _this2.renderer.render()
        });
      }, 10);
    }
  }, {
    key: "getProperty",
    value: function getProperty(objectID, property) {
      var obj = core_1.Prototypes.findObjectById(this.manager.chart, objectID);

      if (!obj) {
        return null;
      }

      return core_1.Prototypes.getProperty(obj, property);
    }
  }, {
    key: "setProperty",
    value: function setProperty(objectID, property, value) {
      var obj = core_1.Prototypes.findObjectById(this.manager.chart, objectID);

      if (!obj) {
        return;
      }

      if (!this.isEqual(core_1.Prototypes.getProperty(obj, property), value)) {
        core_1.Prototypes.setProperty(obj, property, core_1.deepClone(value));
        this.setState({
          working: true
        });
        this.scheduleUpdate();
      }
    }
  }, {
    key: "getAttributeMapping",
    value: function getAttributeMapping(objectID, attribute) {
      var obj = core_1.Prototypes.findObjectById(this.manager.chart, objectID);

      if (!obj) {
        return null;
      }

      return obj.mappings[attribute];
    }
  }, {
    key: "setAttributeMapping",
    value: function setAttributeMapping(objectID, attribute, mapping) {
      var obj = core_1.Prototypes.findObjectById(this.manager.chart, objectID);

      if (!obj) {
        return;
      }

      if (!this.isEqual(obj.mappings[attribute], mapping)) {
        obj.mappings[attribute] = core_1.deepClone(mapping);
        this.setState({
          working: true
        });
        this.scheduleUpdate();
      }
    }
  }, {
    key: "convertGlyphEventHandler",
    value: function convertGlyphEventHandler(handler) {
      if (handler == null) {
        return null;
      }

      return function (element, event) {
        var rowIndices = element.rowIndices;
        var modifiers = {
          ctrlKey: event.ctrlKey,
          shiftKey: event.shiftKey,
          metaKey: event.metaKey
        };
        handler({
          table: element.plotSegment.table,
          rowIndices: rowIndices
        }, modifiers);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var renderOptions = Object.assign({}, this.props.rendererOptions);
      renderOptions.onClick = this.convertGlyphEventHandler(this.props.onGlyphClick);
      renderOptions.onMouseEnter = this.convertGlyphEventHandler(this.props.onGlyphMouseEnter);
      renderOptions.onMouseLeave = this.convertGlyphEventHandler(this.props.onGlyphMouseLeave);
      renderOptions.selection = this.props.selection;
      var gfx = renderer_1.renderGraphicalElementSVG(this.state.graphics, renderOptions);
      var inner = React.createElement("g", {
        transform: "translate(".concat(this.props.width / 2, ", ").concat(this.props.height / 2, ")")
      }, this.props.onGlyphClick ? React.createElement("rect", {
        x: -this.props.width / 2,
        y: -this.props.height / 2,
        width: this.props.width,
        height: this.props.height,
        style: {
          fill: "none",
          pointerEvents: "all",
          stroke: "none"
        },
        onClick: function onClick() {
          _this3.props.onGlyphClick(null, null);
        }
      }) : null, gfx, this.state.working ? React.createElement("rect", {
        x: -this.props.width / 2,
        y: -this.props.height / 2,
        width: this.props.width,
        height: this.props.height,
        style: {
          fill: "rgba(0, 0, 0, 0.1)",
          stroke: "none"
        }
      }) : null);

      switch (this.props.rootElement) {
        case "svg":
          {
            return React.createElement("svg", {
              x: 0,
              y: 0,
              width: this.props.width,
              height: this.props.height,
              className: this.props.className,
              style: {
                userSelect: "none"
              }
            }, inner);
          }

        case "g":
          {
            return React.createElement("g", {
              className: this.props.className
            }, inner);
          }
      }
    }
  }]);

  return ChartComponent;
}(React.Component);

exports.ChartComponent = ChartComponent;